import { render, staticRenderFns } from "./VxCellLuckyRollPrizes.vue?vue&type=template&id=20a38f39&scoped=true&"
import script from "./VxCellLuckyRollPrizes.vue?vue&type=script&lang=js&"
export * from "./VxCellLuckyRollPrizes.vue?vue&type=script&lang=js&"
import style0 from "./VxCellLuckyRollPrizes.vue?vue&type=style&index=0&id=20a38f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a38f39",
  null
  
)

export default component.exports